import { render, staticRenderFns } from "./OfferSheetFlitter.vue?vue&type=template&id=6848d50c&scoped=true&"
import script from "./OfferSheetFlitter.vue?vue&type=script&lang=js&"
export * from "./OfferSheetFlitter.vue?vue&type=script&lang=js&"
import style0 from "./OfferSheetFlitter.vue?vue&type=style&index=0&id=6848d50c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6848d50c",
  null
  
)

export default component.exports